export const environment = {
  ENV: 'test',
  SAPPHIRE_API_URL: 'https://test.api.irisgst.com/irisgst/sapphire/',
  SAPPHIRE_MGMT_API_URL: 'https://test.api.irisgst.com/irisgst/mgmt/',
  SAPPHIRE1_WEB_URL: 'https://test.app.irisgst.com',
  TENANT: 'test',
  APP_NAME: 'IRIS',
  GTAD_MEASUREMENT_ID: '',
  FP_GSTR1: '042024',
  FP_GSTR1A: '072024',
  LOGO_URL: 'assets/logos/iris.full.png',
  TITLE: 'IRIS-GST',
  FAVICON_URL: 'assets/favicon.webp',
  GSTR6_ENABLED: true,
  RECON_ENABLED: true,
};
